export default "__VITE_ASSET__CYlifCN5__"